import { Route, Switch, useRouteMatch } from "react-router-dom"
import { SendEmail } from "./SendEmail";
import { ValidateCode } from "./ValidateCode";
import { ChangePassword } from "./ChangePassword";
import { createContext, useState } from "react";
import api from "../../../Services/api";

interface MyFirstAccessContextProps {
    username: string,
    sendVerificationCode: (username: string) => Promise<boolean>
    validateVerificationCode: (username: string, code: string) => Promise<boolean>
    changePassword: (username: string, password: string, passwordTransaction: string) => Promise<boolean>
}

export const MyFirstAccessContext = createContext<MyFirstAccessContextProps>({} as MyFirstAccessContextProps);

export const MyFirstAccess = () => {

    const isDebug = false;

    let { path } = useRouteMatch();

    const [username, setUsername] = useState('');

    const sendVerificationCode = async (username = '') => {
        if(isDebug) return true;

        try {
            await api.post(`/Operators/checkbyemail/step/1`, {
                username
            });

            setUsername(username);

            return true;
        }
        catch (error){
            if (error.response && error.response.data&& error.response.data.description) 
                return error.response.data.description;
            
            return false;
        }
    }

    const validateVerificationCode = async (username = '', code = '') => {
        if(isDebug) return true;

        try {
            await api.post(`/Operators/checkbyemail/step/2`, {
                username,
                code
            }); 

            return true;
        }   
        catch {
            return false;
        }
    }

    const changePassword = async (username = '', password = '', passwordTransaction = '') => {
        if(isDebug) return true;

        try {
            await api.post(`/Operators/checkbyemail/step/3`, {
                username,
                password,
                passwordTransaction
            });

            return true;
        }
        catch {
            return false;
        }
    }

    return (
        <MyFirstAccessContext.Provider value={{ 
            username, 
            sendVerificationCode, 
            validateVerificationCode,
            changePassword
        }}>
            <Switch>
                <Route exact path={path}>
                    <SendEmail />
                </Route>
                <Route path={`${path}/validate-code`}>
                    <ValidateCode />
                </Route>
                <Route path={`${path}/change-password`}>
                    <ChangePassword />
                </Route>
            </Switch>
        </MyFirstAccessContext.Provider>

    )
}